import { i18n } from '@/boot/i18n';
import { ERROR_CODES } from '../consts/errors';

function getGenericErrorMessage(status) {
  switch (status) {
    case 400:
      return 'general.messages.bad_request';
    case 401:
      return 'general.messages.has_not_permission';
    case 403:
      return 'general.messages.forbidden';
    case 404:
      return 'general.messages.not_found';
    case 422:
      return 'general.messages.unprocessable_entity';
    case 500:
      return 'general.messages.internal_error';
    default:
      return 'general.messages.error';
  }
}

export default {
  getErrorMessage(error, messageParams) {
    let message = '';

    if (error && error?.response?.status === 401) {
      return '';
    }

    if (error && error?.response?.status === 403) {
      return '';
    }

    if (error?.response?.data) {
      const errorData = error.response.data;
      if (errorData.data && Array.isArray(errorData.data)) {
        errorData.data.forEach((data) => {
          if (data.code) {
            message = i18n.t(
              ERROR_CODES[data.code][data.field]
                ? ERROR_CODES[data.code][data.field] : ERROR_CODES[data.code],
              messageParams,
            );
          }
        });
      } else if (errorData.code) {
        message = i18n.t(ERROR_CODES[errorData.code], messageParams);
      }

      if (!message) {
        message = messageParams ? i18n.t(messageParams) : message;
      }
    }

    if (!message) {
      message = i18n.t(getGenericErrorMessage(error?.response?.status));
    }

    return {
      text: message,
      sentryTransactionId: error?.response?.data?.data?.TransactionId || error?.response?.config?.headers['X-Transaction-ID'],
    };
  },
};
